import styled from 'styled-components';

export const UploadContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 8px 4px;
    outline: none;
`;

export const UploadDescription = styled.span`
    text-align: center;
    font-size: 14px;
    color: #939aa4;
`;

export const UploadFooter = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
    width: 100%;

    & > * {
        width: 100%;
    }
`;
